<template>
    <div id="vehicle_option_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="customerHeader1" v-if="isEdit">Update Vehicle Option</span>
                    <span class="page-title" id="customerHeader2" v-else>Create Vehicle Option</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="goPreviousPath">
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="from-group">
                        <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <strong id="errorMsg" class="field-error"></strong>
                        </div>
                    </div>
                    <div class="admin-page-content customer-crud">
                        <section class="internal-container border-top-table-fl">
                          <form autocomplete="off" class="needs-validation" novalidate id="VehicleOptionForm">
                            <div class="form-row">
                              <div class="col-4 form-group">
                                <div class="d-flex justify-content-between">
                                  <label class="control-label require" for="code">Code:</label>
                                  <span style="font-size: 14px;">{{ code_count }}/20</span>
                                </div>
                                <input type="text" class="form-control" v-model.trim="code" id="code"
                                       placeholder="Code" name="code">
                                <span class="field-error">{{ code_error_msg }}</span>
                              </div>
                              <div class="col-4 form-group">
                                <div class="d-flex justify-content-between">
                                  <label class="control-label require" for="model_year">Model Year:</label>
                                </div>
                                <input type="number" class="form-control" v-model.trim="model_year"
                                       id="model_year" placeholder="Model Year" name="model_year">
                                <span class="field-error">{{ model_year_error_msg }}</span>
                              </div>
                              <div v-if="region === 'US'" class="col-4 form-group">
                                <div class="d-flex justify-content-between">
                                  <label class="control-label require" for="price">Price:</label>
                                </div>
                                <input type="text" class="form-control" v-model.trim="price" id="price"
                                       placeholder="Price" name="price" @keypress="filterNumericValue($event)">
                                <span class="field-error">{{ price_error_msg }}</span>
                              </div>
                              <div class="col-4 form-group">
                                <div class="d-flex justify-content-between">
                                  <label class="control-label require" for="dealer">Status</label>
                                </div>
                                <v-select v-model="vehicleOptionStatus" name="vehicleOptionStatus"
                                          placeholder="Select Status"
                                          label="text"
                                          :options="statusArr" id="vehicleOptionStatus"
                                >
                                </v-select>
                                <span class="field-error">{{ status_error_msg }}</span>
                              </div>
                            </div>
                            <div class="form-row">
                              <div class="col-6 form-group">
                                <div class="d-flex justify-content-between">
                                  <label class="control-label require" for="desc">Description:</label>
                                  <span style="font-size: 14px;">{{ desc_count }}/1000</span>
                                </div>
                                <textarea class="form-control" v-model.trim="desc" rows="3" maxlength="1000"
                                          placeholder="Description"></textarea>
                                <span class="field-error">{{ desc_error_msg }}</span>
                              </div>
                            </div>
                            <div class="btn-groups">
                              <button type="submit" id="CreateVehicleOptionBtn" v-if="isEdit"
                                      class="btn btn-primary" v-on:click.prevent="createVehicleOption">
                                <i class="fp-reload"> </i> Update
                              </button>
                              <button type="submit" id="CreateVehicleOptionBtn" v-else class="btn btn-primary"
                                      v-on:click.prevent="createVehicleOption">
                                <i class="fp-save"> </i> Save
                              </button>
                              <button type="submit" v-if="!isEdit" class="btn btn-tertiary"
                                      v-on:click.prevent="createVehicleOption(flag = 'Save and Continue')">
                                <i class="fp-save-continue"> </i> Save and Continue
                              </button>
                              <button type="submit" class="btn btn-tertiary" v-on:click.prevent="goPreviousPath">
                                <i class="fp-close"> </i> Cancel
                              </button>
                            </div>
                          </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import { commonMixins } from '../../mixins/commonMixins';
import { contractMixins } from '../../mixins/contractMixins';

export default {
    name: "VehicleOptionCreate",
    metaInfo() {
        return {
            title: (this.isEdit == true) ? "Update Vehicle Option | " + process.env.COPYRIGHT_NAME : "Create Vehicle Option | " + process.env.COPYRIGHT_NAME
        }
    },
    mixins: [commonMixins, contractMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: "",
        loading: false,
        isEdit: false,
        id: 0,
        code_count: 0,
        code: "",
        code_error_msg: "",
        model_year: "",
        model_year_error_msg: "",
        price: '',
        price_error_msg: "",
        desc_count: 0,
        desc: "",
        desc_error_msg: "",
        statusArr: ['Active','Inactive'],
        vehicleOptionStatus: 'Active',
        status_error_msg: '',
        region: process.env.REGION
    }),

    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (
                        permissions[i].name == 'ev_create_vehicle_option'
                        ||
                        permissions[i].name == 'ev_edit_vehicle_option'
                    ) {
                        self.cantAccessPage = true;
                    }
                }
            }
        },
        code(newValue) {
            if (newValue.length > 20) {
                this.code = newValue.substring(0, 20);
            }
            this.code_count = newValue.length;
        },
        model_year(newValue) {
            if (newValue.length > 4) {
                this.model_year = newValue.substring(0, 4);
            }
        },
        desc(newValue) {
            if (newValue.length > 1000) {
                this.desc = newValue.substring(0, 1000);
            }
            this.desc_count = newValue.length;
        },
        price(newValue) {
            if (
                newValue === ''
                ||
                newValue === null
            ) {
                this.price = '';
            } else if (newValue === '$') {
                this.price = '';
            } else if (!newValue.startsWith('$')) {
                this.price = '$' + newValue;
            }
            // Allow only two decimal points
            const decimalIndex = this.price.indexOf('.');
            if (decimalIndex !== -1) {
                this.price = this.price.substring(0, decimalIndex + 3);
            }
        }
    },
    mounted: function () {
        var self = this;
        self.getPermissions();

        if (
            self.$route.params.id !== undefined
            &&
            self.$route.params.id > 0
        ) {
            self.id = self.$route.params.id;
            self.isEdit = true;
            self.loadSingleVehicleOption();
        }
    },
    methods: {
        validateFields() {
            var self = this;
            self.code_error_msg = "";
            self.model_year_error_msg = "";
            self.price_error_msg = "";
            self.desc_error_msg = "";
            var error = false;

            if (self.code === "" || self.code === null) {
                self.code_error_msg = "Code is Required!";
                error = true;
            }

            if (self.model_year === "" || self.model_year === null) {
                self.model_year_error_msg = "Model Year is Required!";
                error = true;
            } else if (!/^\d{4}$/.test(self.model_year)) {
                self.model_year_error_msg = "Model Year must be a 4-digit number!";
                error = true;
            }

            if(this.region === "US") {
              if (self.price === "" || self.price === null || self.price === "$0") {
                self.price_error_msg = "Price is Required!";
                error = true;
              } else if (!/^\$\d+(\.\d{1,2})?$/.test(self.price)) {
                self.price_error_msg = "Price must be a valid amount!";
                error = true;
              }
            }

            if (self.desc === "" || self.desc === null) {
                self.desc_error_msg = "Description is Required!";
                error = true;
            }

            if (self.vehicleOptionStatus === "" || self.vehicleOptionStatus === null) {
              self.status_error_msg = "Status is Required!";
              error = true;
            }

            return error;
        },
        createVehicleOption(flag) {
            var self = this;
            var error = self.validateFields();
            if (!error) {
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/vehicle-option/store",
                    type: "POST",
                    headers: this.ajxHeaders,
                    data: {
                        option_id: self.id,
                        code: self.code,
                        model_year: self.model_year,
                        price: self.price.replace('$', ''),
                        description: self.desc,
                        status: self.vehicleOptionStatus
                    },
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.code == 200) {
                            if (flag == "Save and Continue") {
                                $("#VehicleOptionForm").trigger("reset");
                                self.id = 0;
                                self.code = "";
                                self.model_year = "";
                                self.price = "";
                                self.desc = "";
                            } else {
                                self.$router.push("/vehicle-option/list");
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR, false, 'save-vehicle-option');
                    }
                });
            }
        },
        loadSingleVehicleOption() {
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/vehicle-option/" + self.id,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.code == 200) {
                        self.code = data.content.code;
                        self.model_year = data.content.model_year;
                        self.price = '$' + data.content.price;
                        self.desc = data.content.description;
                        self.vehicleOptionStatus = self.titleCase(data.content.status);
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'get-single-vehicle-option');
                }
            });
        }
    },
};
</script>



// WEBPACK FOOTER //
// src/components/vehicleOption/VehicleOptionCreate.vue